var ObservableValue = require("../observable/observableValue.js");

// Root extension to add collaboration functionality based on shareJs
var Shareable = {
    makeShareable: function(){
        console.assert(this.isUndoable, "Shareable root extension depends on the undo functionality");
        console.assert(this.hasJsonParser, "Shareable root extension needs a json parser");

        this.sharedDoc = null;  // shared document on the colab service

        this.connected = ObservableValue.createNewFunction(); // connection status to the sharedDocument
        this.saved = ObservableValue.createNewFunction(); // saving status

        this.isShareable = true;
    },

    getEmptyDoc: function(){
        return {
            'header': {},
            'body': {},
            'undo': [],
            'redo': []
        }
    },

    connectTo: function(sharedDoc, nodesToSkip){
        var self = this;
        this.sharedDoc = sharedDoc;

        // connection handlers:
        this.sharedDoc.onConnected = function(){
            self.connected(true);
        };
        this.connected(true);

        this.sharedDoc.onDisconnected = function(){
            self.connected(false);
        };

        this.sharedDoc.onConnectionStopped = function(){
            self.connected(false);
        };

        this.sharedDoc.onError = function(err){
            if (err.retryable) console.log("Share Error: " + err.msg);
            else throw new Error("Share Error: " + err.msg);
        };

        // Change handlers:
        this.sharedDoc.afterUpdate = function(op, remote){
            if (remote) self.applyOperations(op); // on incoming remote changes
            else self.saved(false); // on own changes set saving flag
        };

        this.sharedDoc.onOpAcknowledged = function(v, otList){ // when changes saved on server
            if (self.sharedDoc.numberPending() == 0) self.saved(true);
        };
        this.saved(true);

        this.onFinishAction("__shareAction", this.shareAction);

        // initialize this root with current shared document
        var json = this.sharedDoc.snapshot();
        this.header = json["header"];   // save the header directly in the root: header is not observable and read-only
        var data = this.dejsonify(json["body"], nodesToSkip);   // dejsonify the body in this root as an observable and shared datamodel
        this.attachData(data);

        //THIS IS A HACK AND MUST COME OUT
        if(!json["undo"]) json["undo"] = [];
        if(!json["redo"]) json["redo"] = [];

        this.undoStack = [];
        for (var i = 0; i < json["undo"].length; i++){
            this.undoStack.push(JSON.parse(JSON.stringify(json["undo"][i])));
        }
        this.redoStack = [];
        for (var i = 0; i < json["redo"].length; i++){
            this.redoStack.push(JSON.parse(JSON.stringify(json["redo"][i])));
        }

    },

    // Apply incoming remote changes to this root
    applyOperations: function(op){
        var self = this;
        var recordingBusy = this.isRecording();
        if (recordingBusy) this.pauseRec(); // pause recording

        var action = [];
        for (var i = 0; i < op.length; i++){
            var path = op[i]['p'];
            if (path[0] == "body"){
                var node = this.sharedDoc.get(path.slice(0, -1))['$id'];
                var col = path[path.length-1];
                var key;
                if(!node) {
                    node = this.sharedDoc.get(path.slice(0, -2))['$id'];
                    col = path[path.length-2];
                    key = path[path.length-1];
                }
                var value = op[i]['li'] !== undefined ? op[i]['li'] : op[i]['oi'];
                var oldValue = op[i]['ld'] !== undefined ? op[i]['ld'] : op[i]['od'];
                var type = "change";
                if (value === undefined) type = "remove";
                else if (oldValue === undefined && op[i]['li'] !== undefined) type = "insert";

                var event = [type, node, col, key, value, oldValue];
                action.push(event);
                this._lockState = 1; // make sure only applied event is executed, all coupled events are rejected => TODO: see if we can move set of this flag to undoable
                this.dejsonifyEvent(event).reApply(); // dejsonify and apply event to this datamodel
            }
            else if (path[0] == "undo"){
                var insert = op[i]['li'];
                var remove = op[i]['ld'];
                if (insert !== undefined) this.undoStack.splice(path[1], 0, JSON.parse(JSON.stringify(insert)));
                if (remove !== undefined) this.undoStack.splice(path[1], 1);
            }
            else if (path[0] == "redo"){
                if (op[i]['oi'] instanceof Array && op[i]['oi'].length == 0) this.redoStack = [];
                else {
                    var insert = op[i]['li'];
                    var remove = op[i]['ld'];
                    if (insert !== undefined) this.redoStack.splice(path[1], 0, JSON.parse(JSON.stringify(insert)));
                    if (remove !== undefined) this.redoStack.splice(path[1], 1);
                }
            }
        }

        // call the finishAction handlers
        this._lockState = 0;    // after all incoming changes are applied, root is unlocked
        this.handlers.action.forEach(function(k, handler){
            handler.call(self, action, true);
        });

        if (recordingBusy) this.rec(); // resume recording
    },

    shareAction: function(action, remote){
        if (remote) return; // no need to share incoming actions again

        for (var i = 0; i < action.length; i++){  // TODO: refactor in readable json from the moment events are not directly shared anymore!
            var event = action[i];

            var path = this.jsonifyPath(this.nodeMap.get(event[1]).getPath());
            path.push(event[2]);
            if (event[3] != undefined) path.push(event[3]);
            path.unshift("body");

            switch(event[0]){
                case "change": this.sharedDoc.set(path, event[4]); break;
                case "insert": this.sharedDoc.insert(path, event[4]); break;
                case "remove": this.sharedDoc.remove(path); break;
            }
        }

        // share undo / redo list: TODO: should be removed in the future
        var remoteUndo = this.sharedDoc.get(["undo"]);
        if (remoteUndo.length == this.historyLength) this.sharedDoc.remove(["undo", 0]);
        if (remoteUndo.length == this.undoStack.length - 1) this.sharedDoc.push(["undo"], this.undoStack[this.undoStack.length-1]);
        if (remoteUndo.length == this.undoStack.length + 1) this.sharedDoc.remove(["undo", remoteUndo.length-1]);

        var remoteRedo = this.sharedDoc.get(["redo"]);
        if (remoteRedo.length != 0 && this.redoStack.length == 0) this.sharedDoc.set(["redo"], []);
        else if (remoteRedo.length == this.redoStack.length - 1) this.sharedDoc.push(["redo"], this.redoStack[this.redoStack.length-1]);
        else if (remoteRedo.length == this.redoStack.length + 1) this.sharedDoc.remove(["redo", remoteRedo.length-1]);
    }
};

module.exports = Shareable;